import { useMemo } from "react";
import { useAppSelector } from "../store/hooks";

const REVIEW_PORTAL_ROLES = [
  "Super Admin",
  "Admin",
  "Operations",
  "Admin Read",
  "Production",
];
const REQUIRES_EMPLOYEE_LOGIN = ["Admin", "Operations", "Production"];
const ADMIN_EMP_ROLES = ["admin", "executive", "super admin", "operations"];

export function usePortalReviewAccess() {
  const { user } = useAppSelector((state) => state.auth);
  const { employee } = useAppSelector((state) => state.allocationAuth);

  return useMemo(() => {
    const portalRole = user?.role || "";
    const empRole = (employee?.role || "").trim().toLowerCase();
    const employeeLoggedIn = Boolean(employee?.emp_id);
    const portalAllowed = REVIEW_PORTAL_ROLES.includes(portalRole);

    const canSeeReviewButton =
      portalAllowed &&
      (!REQUIRES_EMPLOYEE_LOGIN.includes(portalRole) || employeeLoggedIn);

    const canSubmit =
      portalAllowed &&
      (employeeLoggedIn || portalRole === "Super Admin");
    const canViewInbox =
      portalRole === "Super Admin" ||
      portalRole === "Admin Read" ||
      ADMIN_EMP_ROLES.includes(empRole);
    const canManage =
      portalRole === "Super Admin" || ADMIN_EMP_ROLES.includes(empRole);

    return {
      canSeeReviewButton,
      canSubmit,
      canViewInbox,
      canManage,
      employee,
      user,
    };
  }, [user, employee]);
}
